import React, { ComponentType } from 'react';
import cn from 'classnames';
import styles from './scroll.module.sass';

interface CustomScrollProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    hidden?: boolean;
    horizontal?: boolean;
}

export const CustomScroll = ({ children, hidden, horizontal, className, ...props }: CustomScrollProps) => {
    const classes = cn(styles.scroll, hidden && styles.hidden, horizontal && styles.horizontal, className);

    return (
        <div className={classes} {...props}>
            {children}
        </div>
    );
};
